import contract from '../../plugins/ethereum_contracts'
import { GET_ETHEREUM_VALUE_MUTATION } from '../mutations'
import web3 from '../../plugins/web3'

const state = {
	circulatingSupply: 3000000, // Somma del valore dei RE20 circolanti
	circulatingSupplyNum: 1, // Numero di RE20 circolanti
	loading: false,
	ethValue: 0
}

const actions = {
	getEthereumValue: (store) => {
		store.commit ('MAKE_REQUEST', {
			endpoint: 'https://api.coinbase.com/v2/prices/ETH-EUR/buy',
			mutation: GET_ETHEREUM_VALUE_MUTATION
		})
	}
}

const mutations = {
	getCirculatingSupply: async state => {
		if (!contract.RE20ICO || !contract.RE721) {
			console.log ('Wrong contracts')
			state.circulatingSupply = 0
			return
		}

		const total = await contract.RE20ICO.methods.totalSupply ().call ()
		state.circulatingSupply = total ? total.toString () : 0
	},

	[GET_ETHEREUM_VALUE_MUTATION.REQUEST]: state => {
		console.log ('request ethereum value')
	},

	[GET_ETHEREUM_VALUE_MUTATION.SUCCESS]: (state, {data}) => {
		state.ethValue = data.data.amount

	},

	[GET_ETHEREUM_VALUE_MUTATION.FAILURE]: (state, response) => {
		console.log ('request ethereum failed')
		console.log (response)
	}
}

const getters = {
	circulatingSupply: state => web3 != null ? web3.utils.fromWei ('' + state.circulatingSupply, 'ether') : 0
}

export default {
	state,
	actions,
	mutations,
	getters
}